export class Logger {
    static info(msg: string, data?: any) {
      console.info(`ℹ️ [INFO]: ${msg}`, data ?? '');
    }
    static warn(msg: string, data?: any) {
      console.warn(`⚠️ [WARN]: ${msg}`, data ?? '');
    }
    static error(msg: string, data?: any) {
      console.error(`❌ [ERROR]: ${msg}`, data ?? '');
    }
    static debug(msg: string, data?: any) {
      if (process.env.NODE_ENV === 'development') {
        console.debug(`🐞 [DEBUG]: ${msg}`, data ?? '');
      }
    }
  }
  